import React from 'react';
import ReactDOM from 'react-dom';
import Chatbot from './chatbot';
import './style.css';


ReactDOM.render(
  <Chatbot />,
  document.getElementById('root')
);